var React = require('react');

function ArrowDiagonalWhiteInvert (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFFFFF","cx":"12","cy":"12","r":"12","key":0}),React.createElement("polygon",{"points":"9.7,6.9 9.7,7.9 15.4,7.9 7.3,15.9 8.1,16.7 16.1,8.6 16.1,14.3 17.1,14.3 17.1,6.9 ","fill":"#000000","key":1})]);
}

ArrowDiagonalWhiteInvert.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = ArrowDiagonalWhiteInvert;

ArrowDiagonalWhiteInvert.default = ArrowDiagonalWhiteInvert;
